import Resource from './common/resource';

class FormSubmissionCollections extends Resource {
  path = 'form/submission_collections';
}

export default FormSubmissionCollections;
